<template>
    <div class="flex-row">
        <el-switch
            v-model="currentValue"
            :active-color="activeSwitchColor"
            :inactive-color="inactiveSwitchColor"
        />
        <div
            @click="currentValue = !currentValue"
            class="pl-2 cpointer typographies-paragraph-medium-regular"
        >
            {{ textLabel }}
        </div>
    </div>
</template>

<script>
import colors from '@sellsy/styleguide/src/_export.scss';

export default {
    props: {
        value: {
            type: Boolean,
            required: true,
        },
        inactiveSwitchColor: {
            type: String,
            required: false,
            default: colors['gray-80'],
        },
        activeSwitchColor: {
            type: String,
            required: false,
            default: colors['success-50'],
        },
        textLabel: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            currentValue: true,
        };
    },
    mounted() {
        this.currentValue = this.value;
    },
    watch: {
        value(newValue) {
            this.currentValue = newValue;
        },
        currentValue(newValue) {
            this.$emit('change', newValue);
        },
    },
};
</script>
